import React, { useState } from "react";
import { useSelector } from "react-redux";
import { staticData } from "managers/staticDataManager";
import { attachmentDownload } from "views/callApi";

const DownloadItem = ({ file, keyIndex, busyHandler, alertRef }) => {
  const state = useSelector((state) => state);
  const [cursorStyle, setCursorStyle] = useState("default");
  const [textDecorationStyle, setTextDecorationStyle] = useState("");
  const clickHandler = async (e) => {
    // console.log('DownloadItem.clickHandler-file: ', file)
    if (file?.attachmentId) {
      return attachmentDownload(
        state,
        file.attachmentId,
        file.fileName,
        busyHandler,
        alertRef
      );
    }
  };

  const iconVisualizer = () => {
    return "nc-icon nc-cloud-download-93";
  };
  const iconlocalizer = () => {
    return "VW_DOCUMENT_DownloadFile";
  };

  const onMouseEnterHandler = (e) => {
    setCursorStyle("pointer");
    setTextDecorationStyle("underline");
  };
  const onMouseLeaveHandler = (e) => {
    setCursorStyle("default");
    setTextDecorationStyle("");
  };

  return (
    <React.Fragment>
      <div
        style={{
          cursor: cursorStyle,
          textDecoration: textDecorationStyle,
          color: "var(--brand-color)",
        }}
        title={`${staticData.loadTerms(useSelector, iconlocalizer())} ${
          file.fileName
        }`}
        onClick={(e) => clickHandler(e)}
        onMouseEnter={(e) => onMouseEnterHandler(e)}
        onMouseLeave={(e) => onMouseLeaveHandler(e)}
      >
        <i
          style={{ cursor: cursorStyle, textDecoration: textDecorationStyle }}
          key={`${file.fileName}-${keyIndex}`}
          className={iconVisualizer()}
        />
        {file.fileName}
      </div>
    </React.Fragment>
  );
};

export default DownloadItem;
